import { cn } from '@change/ds-utils';

const randomWidthsList = [
	'w-40',
	'w-32',
	'w-56',
	'w-40',
	'w-48',
	'w-40',
	'w-64',
	'w-24',
	'w-56',
	'w-32',
	'w-40',
	'w-48',
	'w-56',
	'w-64',
	'w-40',
	'w-32',
	'w-40',
	'w-48',
	'w-40',
	'w-64',
	'w-24',
	'w-56',
	'w-32',
	'w-56',
];

const ChipLoadingSkeleton: React.FC<{ width: string; height: string }> = ({ width, height }) => (
	<div className={cn('bg-fill-press rounded', width, height)} data-testid="loading-skeleton-chip" />
);

type TopicsFilterProps = {
	showTitle?: boolean;
	chipSize?: 'small' | 'large';
};

export const TopicsFilterSkeleton: React.FC<TopicsFilterProps> = ({ showTitle, chipSize }) => (
	<>
		{showTitle && (
			<div className="mt-6 mb-4 animate-pulse" data-testid="loading-skeleton-title">
				<div className="bg-fill-press h-6 w-40 rounded-md" />
			</div>
		)}

		<div className="flex animate-pulse flex-wrap gap-2">
			{randomWidthsList.map((width, index) => (
				<ChipLoadingSkeleton
					// eslint-disable-next-line react/no-array-index-key
					key={`skeleton-chip-${width}-${index}`}
					width={width}
					height={chipSize === 'large' ? 'h-12' : 'h-8'}
				/>
			))}
		</div>
	</>
);
